import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { UnderlineNavigationTab } from 'uiComponents/navigation/underlineNavigationTabs'

export type ProductDetailHeaderTab = UnderlineNavigationTab

interface ProductDetailTabsContextValue {
    detailTabs: ProductDetailHeaderTab[] | null
    showBackToProducts: boolean
    detailTitle: string
    setDetailTitle: (title: string) => void
    setDetailTabs: (tabs: ProductDetailHeaderTab[] | null, options?: { showBackToProducts?: boolean }) => void
}

const ProductDetailTabsContext = createContext<ProductDetailTabsContextValue>({
    detailTabs: null,
    showBackToProducts: false,
    detailTitle: '',
    setDetailTitle: () => {},
    setDetailTabs: () => {},
})

export function ProductDetailTabsProvider({ children }: { children: React.ReactNode }) {
    const [state, setState] = useState<{ tabs: ProductDetailHeaderTab[] | null; showBackToProducts: boolean }>({
        tabs: null,
        showBackToProducts: false,
    })
    const [detailTitle, setDetailTitle] = useState('')
    const setDetailTabs = useCallback(
        (tabs: ProductDetailHeaderTab[] | null, options?: { showBackToProducts?: boolean }) =>
            setState({ tabs, showBackToProducts: !!tabs && !!options?.showBackToProducts }),
        [],
    )
    const value = useMemo(
        () => ({
            detailTabs: state.tabs,
            showBackToProducts: state.showBackToProducts,
            detailTitle,
            setDetailTitle,
            setDetailTabs,
        }),
        [state, detailTitle, setDetailTabs],
    )

    return <ProductDetailTabsContext.Provider value={value}>{children}</ProductDetailTabsContext.Provider>
}

export function useProductDetailTabs() {
    return useContext(ProductDetailTabsContext)
}
